import React from 'react';

import postalCodeNormalizerCA from '../validate/postalCodeNormalizerCA';
import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsCA } from './addressValidation';
import addressFields from './addressFieldMessages';
import canadianProvinceMap, { canadianProvinceField } from './data/CAProvinceMap';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';


export const makeProvinceList = (intl) => {
    const provinces = Object.keys(canadianProvinceMap);
    const placeholder = {
        value: '',
        label: intl.formatMessage(canadianProvinceField.provinceLabel)
    };
    return [placeholder].concat(provinces.map(code => ({
        value: code,
        label: intl.formatMessage(canadianProvinceMap[code])
    })));
};


export const AddressFieldsCA = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.CA.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.CA.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.CA.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.CA.stateLabel,
        options: makeProvinceList(intl),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        label: addressFields.CA.postalCodeLabel,
        normalize: postalCodeNormalizerCA,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsCA.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsCA
};

AddressFieldsCA.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsCA;
